<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters align-center mb-4">
  <v-col 
    cols="12" 
    sm="6" 
    md="5" 
    lg="5" 
    :md="$canRoute('registered-user?tab=7') !== 1 ? 9 : 5" 
    :lg="$canRoute('registered-user?tab=7') !== 1 ? 9 : 5"
  >
    <v-text-field 
      v-model="search" 
      @input="debounceSearch" 
      prepend-inner-icon="mdi-magnify" 
      label="Search" 
      single-line
      hide-details
      filled
      dense
      flat
      class="custom-search-input"
      :background-color="$vuetify.theme.dark ? '#1c2835' : '#f1f5f9'"
    ></v-text-field>
  </v-col>

  <v-col cols="12" sm="3" md="4" lg="4" class="d-flex justify-center px-4">
    <div class="d-flex align-center">
      <div class="mr-6 text-center">
        <span class="caption blue--text text--lighten-1 font-weight-bold d-block">Total Balance</span>
        <span class="text-h6 font-weight-bold success--text">
          {{ parseFloat(totalBalance.toFixed(2)) }}
        </span>
      </div>
      <div class="text-center">
        <span class="caption grey--text font-weight-bold d-block">Total Account</span>
        <span class="text-h6 font-weight-bold" :class="$vuetify.theme.dark ? 'white--text' : 'black--text'">
          {{ totalAccounts }}
        </span>
      </div>
    </div>
  </v-col>

  <v-col 
    cols="12" 
    sm="3" 
    md="3" 
    lg="3" 
    class="text-right" 
    v-if="$canRoute('registered-user?tab=7') === 1"
  >
    <v-btn 
      tile 
      elevation="0" 
      color="#ff3b3b" 
      dark
      @click="disableAllAccount(accounts)"
      class="text-capitalize px-6 rounded" 
      :disabled="isAllDisabledCalled || !accounts.length"
      height="40"
    >
      <v-progress-circular v-if="isAllDisabledCalled" indeterminate size="20" color="white" class="mr-2"></v-progress-circular>
      <span v-if="!isAllDisabledCalled"> Disable All Acc. & Delete </span>
    </v-btn>
  </v-col>
</v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable registerUserTable"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="accounts" :loading="isLoading" :options.sync="tableOptions"
              @update:options="handleOptionsChange">
              <template v-slot:item.InactiveAccount="{ item }">
                <span> {{ item.trading_account_no }} </span>
              </template>

              <template v-slot:item.Equity="{ item }">
                <span> {{ Number.isInteger(item.Equity) ? `${item.Equity}.00` : parseFloat(item.Equity.toFixed(2)) }}
                </span>
              </template>

              <template v-slot:item.Balance="{ item }">
                <span> {{ Number.isInteger(item.Balance) ? `${item.Balance}.00` : parseFloat(item.Balance.toFixed(2)) }}
                </span>
              </template>

              <template v-slot:item.fullname="{ item }">
                <router-link class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item.client_account_id}`">
                  {{ item.fname }} {{ item.lname }}
                </router-link>
              </template>

              <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.trading_account_no] ? 'green' : ''">
                        {{
                          copiedStates[item.trading_account_no]
                            ? "mdi mdi-check"
                            : "mdi-content-copy"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.email }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.details="{ item }">
                <router-link class="links text-decoration-none"
                  :to="`/registered-user-details/${item.client_account_id}`">
                  <v-icon color="#039de9" small>
                    mdi-eye-outline
                  </v-icon>
                </router-link>
              </template>

              <template v-slot:item.ActionView="{ item }">
                <div class="circle-indicator">
                  <v-btn v-if="processingId !== item.trading_account_no" @click="disableAccount(item)"
                    :disabled="isAllDisabledCalled" icon small class="ml-0.5 mb-0.5" color="#FF567F">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                  <v-progress-circular v-else indeterminate size="20" color="#FF567F"></v-progress-circular>
                </div>
              </template>

              <template v-slot:no-data>
                <div class="text-center py-4">
                  <p>No inactive accounts found</p>
                </div>
              </template>
              <template v-slot:loading>
                <div class="text-center py-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <p class="mt-2">Loading accounts data...</p>
                </div>
              </template>

            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { LOWBALANCEACCOUNTS__ACTIONS } from '@/store/action-types';
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      isAllDisabledCalled: false,
      processingId: null,
      copiedStates: {},
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: "Inactive Acc.", value: "InactiveAccount" },
        { text: "Equity", value: "Equity" },
        { text: "Balance", value: "Balance" },
        { text: "User Name", value: "fullname" },
        { text: "Email", value: "email" },
      ]
    }
  },
  computed: {
    ...mapState("lowbalanceaccounts", [
      "accounts",
      "totalAccounts",
      "totalBalance",
      "pagination",
      "isLoading",
    ]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("lowbalanceaccounts", [
      LOWBALANCEACCOUNTS__ACTIONS.LOWBALANCEACCOUNTS,
      LOWBALANCEACCOUNTS__ACTIONS.LOWBALANCEACCOUNTDISABLE
    ]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },

    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.trading_account_no, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.trading_account_no, false);
      }, 1000);
    },

    downloadExcel() {
      const wb = XLSX.utils.book_new();
      const apiData = this.accounts;

      const modifiedData = apiData.map((item) => ({
        "USER ID": item.client_account_id,
        NAME: item.fname + " " + item.lname,
        EMAIL: item.email,
        "REGISTERED AT": item.created_at,
        PASSWORD: item.password,
        "INVESTOR PASSWORD": item.investor_password,
        LEVERAGE: item.leverage,
        EQUITY: item.Equity || "N/A",
        BALANCE: item.Balance || "N/A",
      }));

      const ws = XLSX.utils.json_to_sheet(modifiedData);
      XLSX.utils.book_append_sheet(wb, ws, "Low Balance Accounts");
      const totalRow = modifiedData.length + 2;

      ws["!ref"] = XLSX.utils.encode_range({
        s: { c: 0, r: 0 },
        e: { c: 9, r: totalRow },
      });

      XLSX.writeFile(wb, "low_balance_accounts.xlsx");
    },

    async disableAccount(item) {
      if (this.processingId) return;
      try {
        this.processingId = item.trading_account_no;
        const data = [item];
        await this[LOWBALANCEACCOUNTS__ACTIONS.LOWBALANCEACCOUNTDISABLE](data);
        await this.fetchData();

      } catch (error) {
        console.error('Error disabling account:', error);
      } finally {
        this.processingId = null;
      }
    },

    async disableAllAccount(items) {
      if (!items.length || this.isAllDisabledCalled) return;

      try {
        this.isAllDisabledCalled = true;
        await this[LOWBALANCEACCOUNTS__ACTIONS.LOWBALANCEACCOUNTDISABLE](items);
        await this.fetchData();

      } catch (error) {
        console.error('Error disabling all accounts:', error);
      } finally {
        this.isAllDisabledCalled = false;
      }
    },

    async fetchData() {
      try {
        const parameter = {
          page: this.tableOptions.page || 1,
          limit: this.tableOptions.itemsPerPage || 10,
          search: this.search ? this.search.trim() : ''
        };
        await this[LOWBALANCEACCOUNTS__ACTIONS.LOWBALANCEACCOUNTS](parameter);
      } catch (error) {
        console.log('Error fetching low balance accounts:', error);
      }
    },

    async handleSearch() {
      this.tableOptions.page = 1;
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange() {
      this.fetchData();
    },

    accountFilter() {
      this.tableOptions.page = 1;
      this.fetchData();
    },
  },
  watch: {
    accounts() {
      this.processingId = null;
    }
  },
  async created() {
    this.processingId = null;
    await this.fetchData();
    if (this.$canRoute('registered-user?tab=7') === 1) {
      this.headers.push({ text: "Disable & Delete", value: "ActionView" });
      this.headers.push({ text: "Details", value: "details" });
    }
  },
  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
};
</script>
<style>
.custom-search-input >>> .v-input__slot {
  border-radius: 4px !important;
}
.custom-search-input >>> .v-input__slot::before,
.custom-search-input >>> .v-input__slot::after {
  display: none !important;
}
</style>